const legacyOperationalRedirects = [
  { path: '/dashboard', redirect: '/operational/dashboard' },
  { path: '/kyc', redirect: '/operational/kyc' },
  { path: '/kyb', redirect: '/operational/kyb' },
  { path: '/fee', redirect: '/operational/fee' },
  { path: '/logs', redirect: '/operational/logs' },
  { path: '/med', redirect: '/operational/med' },
  { path: '/infractions', redirect: '/operational/infractions' },
  { path: '/operational/access-control', redirect: '/access-control' },
  { path: '/pix-keys', redirect: '/operational/pix-keys' },
  { path: '/limits-list', redirect: '/operational/limits-list' },
  { path: '/error-cases', redirect: '/operational/error-cases' },
  { path: '/transactions', redirect: '/operational/transactions' },
  { path: '/merchantApi', redirect: '/operational/merchantApi' },
  {
    path: '/users/:user_id(.*)',
    redirect: to => ({ path: `/operational/users/${to.params.user_id}` }),
  },
  {
    path: '/transactions/:trade_no(.*)',
    redirect: to => ({ path: `/operational/transactions/${to.params.trade_no}` }),
  },
  {
    path: '/med/:case_id(.*)',
    redirect: to => ({ path: `/operational/med/${to.params.case_id}` }),
  },
  { path: '/users', redirect: '/operational/users' },
]

export const redirects = [
  {
    path: '/',
    name: 'index',
    redirect: to => {
      return { name: 'login' }
    },
  },
  ...legacyOperationalRedirects,
]
